 <template>

</template>
 
 <script>
export default {
  mounted () {
    const loading = this.$loading({
      lock: true,
      text: '正在验证登陆，请稍后....',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    var casUserInfo = JSON.parse(this.$getCookie("casInfo") || '{}');
    if (casUserInfo.user && casUserInfo.user.login_name)
    {
      let _this = this;
      this.$axios
        .post('/webapi/SeedEnt/ent/cas/validate', casUserInfo.user, {
          loading: false
        })
        .then((data) => {
          loading.close();
          _this.islogin = false;
          if (data.User && data.Msg == '登录成功')
            _this.SucLogin(data.User, data.Token);
          else
            _this.$notify.warning({
              title: '登录失败',
              message: data.Msg
            })
        })
        .catch(() => {
          _this.islogin = false
        })
    }
    else
      window.location.href = "/login.aspx";
  },
  methods: {
    SucLogin (user, token) {
      var _this = this;
      var roles = ['normal'];
      if (user.IsGLZZC == 1)
        roles.push("GLZZC");
      if (user.IsZCCK == 1)
        roles.push("ZCCK");
      if (user.IsYZDW == 1)
        roles.push("YZDW");
      if (user.IsJWYZDW == 1)
        roles.push("JWYZDW");
      delete user.token;
      _this.setSession(user, token, roles);
      _this.$router.push({ path: '/' });
    },
    setSession (user, token, roles) {
      this.$store.dispatch('setToken', token)
      this.$store.dispatch('setUser', user)
      this.$store.dispatch('setRole', roles)
    },
  }
}
 </script>
 
 <style>
</style>


// WEBPACK FOOTER //
// src/views/login/index.vue